import { useAuth } from "@/lib/auth";
import { ShieldAlert, LogOut } from "lucide-react";
import { toast } from "sonner";

/**
 * Sticky banner shown when an admin is currently impersonating a member.
 * Detected by the presence of `samara_impersonator_token` in localStorage.
 */
export default function ImpersonationBanner() {
  const { user, endImpersonation } = useAuth();
  const isImpersonating = typeof window !== "undefined" && !!localStorage.getItem("samara_impersonator_token");

  if (!user || !isImpersonating) return null;

  const handleEnd = async () => {
    toast.success("Returning to admin session…");
    // endImpersonation() does a hard window.location.assign('/admin') internally.
    await endImpersonation();
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed top-0 left-0 right-0 z-[70] bg-rose text-white px-5 py-2 flex items-center justify-center gap-3 shadow-lg"
    >
      <ShieldAlert size={16} className="shrink-0" />
      <div className="text-xs sm:text-sm">
        Admin impersonation active — viewing as <strong>{user.name}</strong>{" "}
        <span className="opacity-70">({user.user_code})</span>
      </div>
      <button
        onClick={handleEnd}
        data-testid="end-impersonation-btn"
        className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest bg-white/10 hover:bg-white/20 px-3 py-1 rounded-sm border border-white/20"
      >
        <LogOut size={11} /> End session
      </button>
    </div>
  );
}
